import Godfather from './godfather.entity';

export default class Employee {
  id: string;

  godfather: Godfather

  admissionDate: string;

  db1StartDate: string;

  name: string;

  username: string;

  businessUnit: string;

  role: string;

  manager: string;

  isAccompanied: boolean;

  hardSkills: string[];

  frameworks: string[];

  businessExperiences: string[];

  certifications: string[];

  managerEmails: string[];

  availableEmails: string[];

  email: string[];

  resignationDate: string;

  techLeadAvailableEmails: string[];

  isManager: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.godfather = Godfather.of(obj.godFatherDTO);
    this.admissionDate = obj.admissionDate || '';
    this.db1StartDate = obj.db1StartDate || this.admissionDate;
    this.name = obj.name || '';
    this.username = obj.username || '';
    this.businessUnit = obj.businessUnit || '';
    this.role = obj.role || '';
    this.manager = obj.manager || '';
    this.isAccompanied = obj.isAccompanied;
    this.hardSkills = obj.hardSkills || [];
    this.frameworks = obj.frameworks || [];
    this.businessExperiences = obj.businessExperiences || [];
    this.certifications = obj.certifications || [];
    this.managerEmails = obj.managerEmails || [];
    this.availableEmails = obj.availableEmails || [];
    this.email = obj.email || [];
    this.resignationDate = obj.resignationDate || '';
    this.techLeadAvailableEmails = obj.techLeadAvailableEmails || [];
    this.isManager = obj.isManager || false;
  }

  public static of(obj: any): Employee {
    return new Employee(obj || {});
  }

  public static ofList(obj: any[]): Employee[] {
    return obj.map(this.of);
  }

  get isResigned(): boolean {
    return !!this.resignationDate;
  }

  get hasDb1StartDateDifferentFromAdmission(): boolean {
    return this.db1StartDate !== this.admissionDate;
  }

  get showAdmissionDate(): boolean {
    return this.isResigned && this.hasDb1StartDateDifferentFromAdmission;
  }

  isCurrentManager(userEmail: string) {
    const managerEmailsLower = this.managerEmails.map(el => el.toLowerCase());
    return managerEmailsLower.includes(userEmail.toLowerCase());
  }
}
